var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-input",class:[_vm.classString, {'error': _vm.error}]},[_c('span',{staticClass:"label"},[_c('Label',{attrs:{"label":_vm.element.label + ' ' + _vm.text.disabled_label_suffix,"tooltip":_vm.element.tooltip}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }